import { SideModal } from "shared";
import SVG from "shared/SVG";
import { SVG_ENUM } from "enums";
import "../InvestmentPolicyDetailsSideModal/InvestmentPolicyDetailsSideModal.scss";
import "../ArtworkDetailsSideModal/ArtworkDetailsSideModal.scss";

interface TreasuryBondsDetailsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: any | null;
}

const INTEREST_TYPE_LABELS: Record<string, string> = {
  fixed: "Stałe",
  variable: "Zmienne",
  periodically_fixed: "Okresowo-stałe",
};

const TreasuryBondsDetailsSideModal = ({
  isOpen,
  onClose,
  item,
}: TreasuryBondsDetailsSideModalProps) => {
  const getInterestTypeText = (): string => {
    if (!item) return "Brak";
    const interestType =
      item.details?.interestRateType || item.details?.interestType;
    if (!interestType) return "Brak";
    return INTEREST_TYPE_LABELS[interestType] || interestType;
  };

  const getInterestRateText = (): string => {
    if (!item) return "Brak";
    const rate = item.details?.interestRate;
    if (rate === null || rate === undefined || rate === "") return "Brak";
    return `${rate}%`;
  };

  const getQuantityText = (): string => {
    if (!item) return "Brak";
    const quantity = item.quantity;
    if (quantity === null || quantity === undefined) return "Brak";
    return String(quantity);
  };

  const getAcquisitionCostText = (): string => {
    if (!item) return "Brak";
    const cost = item.primaryValue;
    const currency = item.currency?.currency;
    if (cost === null || cost === undefined) return "Brak";
    const value = Number(cost);
    const formattedCost = Number.isInteger(value)
      ? value.toLocaleString("pl-PL")
      : value.toLocaleString("pl-PL", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
    return currency ? `${formattedCost} ${currency}` : formattedCost;
  };

  const contractFiles = (item?.files ?? []).filter(
    (f: any) => f.role === "contract",
  );

  const handleDownloadAll = () => {
    if (!item) return;
    contractFiles.forEach((file: any) => {
      const link = document.createElement("a");
      link.href = file.file.url;
      link.download = file.file.name;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Szczegółowe informacje"
      subtitle="Aktywo: Obligacje skarbowe"
    >
      <div className="investment-policy-details">
        <div className="artwork-details__price-header">
          Koszt nabycia: <span>{getAcquisitionCostText()}</span>
        </div>

        <div className="investment-policy-details__field">
          <span className="investment-policy-details__label">
            Rodzaj oprocentowania
          </span>
          <span className="investment-policy-details__value">
            {getInterestTypeText()}
          </span>
        </div>

        <div className="investment-policy-details__field">
          <span className="investment-policy-details__label">Ilość sztuk</span>
          <span className="investment-policy-details__value">
            {getQuantityText()}
          </span>
        </div>

        <div className="investment-policy-details__field">
          <span className="investment-policy-details__label">
            Wysokość oprocentowania
          </span>
          <span className="investment-policy-details__value">
            {getInterestRateText()}
          </span>
        </div>

        <div className="investment-policy-details__field">
          <span className="investment-policy-details__label">
            Dodatkowe informacje
          </span>
          <span className="investment-policy-details__value">
            {item?.additionalInfo || "Brak"}
          </span>
        </div>

        <div className="investment-policy-details__field investment-policy-details__field--files">
          <div className="investment-policy-details__files-header">
            <span className="investment-policy-details__label">Umowy</span>
            {contractFiles.length > 0 && (
              <button
                className="investment-policy-details__download-all"
                onClick={handleDownloadAll}
              >
                Pobierz wszystko
                <SVG type={SVG_ENUM.FILE_DOWNLOAD} />
              </button>
            )}
          </div>
          {contractFiles.length === 0 ? (
            <span className="investment-policy-details__value">Brak</span>
          ) : (
            <div className="investment-policy-details__files-list">
              {contractFiles.map((file: any) => (
                <div
                  key={file.file.uuid}
                  className="investment-policy-details__file-item"
                >
                  <span className="investment-policy-details__file-name">
                    {file.file.name}
                  </span>
                  <a
                    href={file.file.url}
                    download={file.file.name}
                    target="_blank"
                    rel="noreferrer"
                    className="investment-policy-details__file-download"
                  >
                    <SVG type={SVG_ENUM.FILE_DOWNLOAD} />
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </SideModal>
  );
};

export default TreasuryBondsDetailsSideModal;
